<template>
    <div :class="{'striped-section--empty' : sets.length == 0}" class="l-bg">
        <section class="pt-5 pb-0 py-md-10" v-if="sets.length > 0">
            <div class="container">
                <h2 class="title">{{$t('components.SetRadio.selectBed')}}</h2>
                <p class="mb-4">{{$t('components.SetRadio.selectBedToPrefill')}}</p>
                <div class="grid">
                    <SetRadioItemEmpty @click.native="setItem(0)"></SetRadioItemEmpty>
                    <SetRadioItem :key="set.id" :set="set" @click.native="setItem(set.id)" v-for="set in sets"></SetRadioItem>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        computed: {
            sets: function () {
                return this.$store.state.configurator.productSets;
            },
        },
        methods: {
            setItem: function (uid) {
                if(!this.isSelectedSet(uid)) {
                    this.$store.dispatch("setProductSet", {selectedSet: uid});
                } else {
                    this.$store.dispatch("scrollToConfigurator");
                }
            },
            isSelectedSet: function (id) {
                return this.$store.getters.isSelectedThisSet(id);
            }
        },
        created: function () {
            if(
                this.sets.length <= 0 // no prefilled sets
                && this.$store.state.configurator.configurator.items.length <= 0 // no item already selected
            ) {
                this.setItem(0);
            }
        }
    };
</script>
